import React from "react";
import "./style.css";
import Button from "components/Button/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Badge from "react-bootstrap/Badge";
import Carousel from "react-bootstrap/Carousel";
import { user_access_level, user_Status } from "Api/Api";
import { NavLink } from "react-router-dom";
import { local_routes } from "utils/Routes";

import FollowButton from "components/FollowButton/FollowButton";

const CityBanner = (props) => {
const {
    carouselImage,
    noOrganizer,
    facebookHandle,
    twitterHandle,
    instagramHandle,
    youtubeHandle,
    locationOwner,
    cityDes,
  } = props;
    
    return (
      <div className="main-section">
        <React.Fragment>
          {carouselImage.length > 0 ? (
            <Carousel
              fade={true}
              pause={"hover"}
              controls={false}
              indicators={false}
              interval={5000}
            >
              {carouselImage.map((img, i) => {
                let url = img;
                let array = url.split("/");
                const convImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1400x400/${array[5]}`;
                return (
                  <Carousel.Item
                    key={i}
                    className="fade-carousel"
                    style={{ height: "100%" }}
                  >
                    <div
                      className="eventImage city-new-image"
                      style={{
                        minHeight: "350px",
                        backgroundImage: "url(" + convImg + ")",
                      }}
                    >
                      <div className="container">
                        <div className="row">
                          <Col sm={12} md={12} lg={12}>
                            <Row className="align-items-center">
                              <Col md={7} lg={5}>
                                {/* event-cover */}
                                <div className="city-detail">
                                  <img
                                    src={props.logoCity}
                                    alt="logo-img"
                                  />
                                  <h1>{props.cityName}</h1>
                                  <p
                                    className={
                                      cityDes.length > 100
                                        ? "scroll-data"
                                        : undefined
                                    }
                                    dangerouslySetInnerHTML={{
                                      __html: cityDes,
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col md={5} lg={4} className="ml-auto">
                                {noOrganizer && (
                                  <div className="open-city">
                                    <h4>{props.openCityHeading}</h4>
                                    <p>{props.openCityDes}</p>
                                    <NavLink to="/hostevent">
                                      <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 w-auto">
                                        Apply Here
                                      </Button>
                                    </NavLink>
                                  </div>
                                )}

                                {
                                  // eslint-disable-next-line
                                  ((user_Status === 1 &&
                                    locationOwner === true) ||
                                    (user_Status === 1 &&
                                      user_access_level === "admin")) && (
                                    <NavLink
                                      to={`${local_routes.managecity}/${props.friendly_url}`}
                                    >
                                      <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                        Manage City
                                      </Button>
                                    </NavLink>
                                  )
                                }
                                <div className="city-social-icons">
                                  {facebookHandle && (
                                    <a
                                      rel="noopener noreferrer"
                                      href={`https://www.facebook.com/${facebookHandle}`}
                                      target="_blank"
                                    >
                                      <Badge variant="light">
                                        <i className="fa fa-facebook-square"></i>
                                      </Badge>
                                    </a>
                                  )}
                                  {twitterHandle && (
                                    <a
                                      rel="noopener noreferrer"
                                      href={`https://www.twitter.com/${twitterHandle}`}
                                      target="_blank"
                                    >
                                      <Badge variant="light">
                                        <i className="fa fa-twitter"></i>
                                      </Badge>
                                    </a>
                                  )}
                                  {instagramHandle && (
                                    <a
                                      rel="noopener noreferrer"
                                      href={`https://www.instagram.com/${instagramHandle}`}
                                      target="_blank"
                                    >
                                      <Badge variant="light">
                                        <i className="fa fa-instagram"></i>
                                      </Badge>
                                    </a>
                                  )}
                                  {youtubeHandle && (
                                    <a
                                      rel="noopener noreferrer"
                                      href={`https://www.youtube.com/${youtubeHandle}`}
                                      target="_blank"
                                    >
                                      <Badge variant="light">
                                        <i className="fa fa-youtube-play"></i>
                                      </Badge>
                                    </a>
                                  )}

                                  <FollowButton
                                    entity_info={{
                                      entity_type: "locations",
                                      ...props.city_info,
                                    }}
                                    followed={props.followed}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          ) : (
            <div
              className="eventImage city-new-image"
              style={{ backgroundColor: "#343E48" }}
            >
              <div className="container">
                <div className="row">
                  <Col sm={12} md={12} lg={12}>
                    <Row className="align-items-center">
                      <Col md={7} lg={5}>
                        {/* event-cover */}
                        <div className="city-detail">
                          <img src={props.logoCity} alt="logo-img" />
                          <h1>{props.cityName}</h1>
                          <p>{props.cityDes}</p>
                        </div>
                      </Col>
                      <Col md={5} lg={4} className="ml-auto">
                        {noOrganizer && (
                          <div className="open-city">
                            <h4>{props.openCityHeading}</h4>
                            <p>{props.openCityDes}</p>
                            <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 w-auto">
                              Apply Here
                            </Button>
                          </div>
                        )}

                        {
                          // eslint-disable-next-line
                          ((user_Status === 1 && locationOwner === true) ||
                            (user_Status === 1 &&
                              user_access_level === "admin")) && (
                            <NavLink
                              to={`${local_routes.managecity}/${props.friendly_url}`}
                            >
                              <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Manage City
                              </Button>
                            </NavLink>
                          )
                        }
                        <div className="city-social-icons">
                          {facebookHandle && (
                            <a
                              rel="noopener noreferrer"
                              href={`https://www.facebook.com/${facebookHandle}`}
                              target="_blank"
                            >
                              <Badge variant="light">
                                <i className="fa fa-facebook-square"></i>
                              </Badge>
                            </a>
                          )}
                          {twitterHandle && (
                            <a
                              rel="noopener noreferrer"
                              href={`https://www.twitter.com/${twitterHandle}`}
                              target="_blank"
                            >
                              <Badge variant="light">
                                <i className="fa fa-twitter"></i>
                              </Badge>
                            </a>
                          )}
                          {instagramHandle && (
                            <a
                              rel="noopener noreferrer"
                              href={`https://www.instagram.com/${instagramHandle}`}
                              target="_blank"
                            >
                              <Badge variant="light">
                                <i className="fa fa-instagram"></i>
                              </Badge>
                            </a>
                          )}
                          {youtubeHandle && (
                            <a
                              rel="noopener noreferrer"
                              href={`https://www.youtube.com/${youtubeHandle}`}
                              target="_blank"
                            >
                              <Badge variant="light">
                                <i className="fa fa-youtube-play"></i>
                              </Badge>
                            </a>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </div>
            </div>
          )}

          {/* Banner section Ends */}
        </React.Fragment>
      </div>
    );
}

export default CityBanner;
